export default "__VITE_ASSET__cda4414c__"